import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Text, Textarea, TextInput } from "evergreen-ui";
import { message, Select } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

function randomInteger(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}
const db = getDatabase(Firebase);
const VolunteerActionLayout = (props) => {
	const [langArray] = useListVals(ref(db, "talmidsdb/languages"));
	const [selectedLang, setSelectedLang] = useState(null);
	const [name, setName] = useState(null);
	const [code, setCode] = useState(null);

	const handleLang = (value) => {
		setSelectedLang(value);
	}

	const handleCreate = () => {
		if (!name?.trim() || !code?.trim() || !selectedLang) {
			message.error("Name, code and language are required.");
			return;
		}

		if (name.includes("/")) {
			message.error("The name cannot include a slash, use a dash or another symbol instead.");
		} else {
			var number = randomInteger(10000, 20000);
			const trimmedName = name.trim();
			const trimmedCode = code.trim();

			var objectID = trimmedName + "-" + number;
			var object = {
				"volunteerType": trimmedName,
				"id": objectID,
				"language": selectedLang,
				"volunteerTypeCode": trimmedCode
			}
			setSelectedLang(""); setName(""); setCode("");
			props.createCallback("volunteerTypes", objectID, object);
		}
	}

	return (
		<div className="font-Nunito">
			<MDBRow className="d-flex justify-content-center">
				<MDBCol>
					<div className="d-flex flex-column">
						<Text className=" mb-1">Enter Worker type</Text>
						<TextInput
							className="w-100"
							name="text-input-name"
							placeholder="enter Worker type name"
							onChange={(e) => { setName(e.target.value) }}
							value={name}
						/>
					</div>
					<div className="d-flex flex-column my-2">
						<Text className=" mb-1">Enter Worker Type Code</Text>
						<TextInput
							className="w-100"
							name="text-input-name"
							placeholder="enter Worker type"
							onChange={(e) => { setCode(e.target.value) }}
							value={code}
						/>
					</div>
					<div className="d-flex flex-column my-2">
						<Text className=" mb-1">Select Worker Type Language</Text>
						<Select placeholder="Select Language"
							value={selectedLang}
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
							onChange={handleLang}>
							{langArray.map((item, index) => (
								<Select.Option value={item.id}>{item.languageName}</Select.Option>
							))}

						</Select>
					</div>
					<Button appearance="primary" className="mt-3" onClick={() => {
						handleCreate();
					}}>Add</Button>
				</MDBCol>
			</MDBRow>
		</div>
	)
}
export default VolunteerActionLayout;
